import * as React from "react";
import 'shared/styles/bootstrap.scss'
import {DeactivationDialog} from "./DeactivationDialog";
import './Style.scss';
import {Dialog} from "../../shared/controls/Dialogs/core/Dialog";

jQuery(()=> {
    var wpformDeactivationLink = jQuery('[data-slug="pdf-builder-for-gravity"] .deactivate a').attr('href');
    jQuery('[data-slug="pdf-builder-for-gravity"] .deactivate a').click((e) => {

        try {
            Dialog.Show(<DeactivationDialog/>);
            e.preventDefault();
        } catch (exception) {

        }
    });
});


(window as any).wpformDeactivationLink=jQuery('[data-slug="pdf-builder-for-gravity"] .deactivate a').attr('href');